import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChefHat, Snowflake, Truck, Cpu, Package, Thermometer, Scale } from "lucide-react";
import PageHeader from "../components/PageHeader";
import useReveal from "../hooks/useReveal";
import { images, navPaths } from "../mock/mock";
import { useLang } from "../i18n/LanguageContext";
import Seo from "../components/Seo";

const stepIcons = [ChefHat, Snowflake, Truck, Cpu];
const stepImages = ["chefsKitchen", "labFactory", "technique", "molecular"];
const specIcons = [Package, Scale, Thermometer];

export default function CosaFacciamo() {
  const { t } = useLang();
  useReveal([t]);
  const w = t.whatWeDo;
  return (
    <main>
      <Seo
        title="Cosa Facciamo | Dalla ricetta alla tavola, cottura automatizzata"
        description="Il processo MichelChef®: oltre 400 ricette, abbattimento, monoporzioni gourmet e cottura automatizzata per una qualità costante ovunque."
        path="/cosa-facciamo"
        image={images.labFactory}
      />
      <PageHeader crumb={w.crumb} eyebrow={w.eyebrow} title={w.title} subtitle={w.subtitle} image={images.labFactory} homeLabel={t.common.home} />

      <section className="py-16 bg-[#17784A]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid sm:grid-cols-3 gap-8">
          {w.specs.map((s, i) => {
            const Icon = specIcons[i];
            return (
              <div key={i} className={`reveal reveal-delay-${i} flex items-center gap-4 text-white`}>
                <span className="grid place-items-center w-14 h-14 rounded-2xl bg-white/10 shrink-0"><Icon size={26} /></span>
                <div>
                  <div className="font-display font-extrabold text-2xl lg:text-3xl">{s.value}</div>
                  <div className="text-white/70 text-sm">{s.label}</div>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="py-24 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="space-y-16">
          {t.steps.map((s, i) => {
            const Icon = stepIcons[i];
            const reversed = i % 2 === 1;
            return (
              <div key={i} className="reveal grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
                <div className={reversed ? "lg:order-2" : ""}>
                  <div className="flex items-center gap-4">
                    <span className="grid place-items-center w-14 h-14 rounded-2xl bg-[#17784A] text-white"><Icon size={26} /></span>
                    <span className="font-display font-extrabold text-5xl text-[#F3EFE7]">{s.step}</span>
                  </div>
                  <h2 className="font-display font-extrabold text-3xl lg:text-4xl mt-6 text-[#14110F]">{s.title}</h2>
                  <p className="mt-5 text-[#3B342E]/90 text-lg leading-relaxed">{s.text}</p>
                </div>
                <div className={reversed ? "lg:order-1" : ""}>
                  <img src={images[stepImages[i]]} alt="" className="rounded-3xl w-full h-[360px] object-cover shadow-2xl card-lift" />
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="pb-24 max-w-7xl mx-auto px-5 lg:px-8">
        <div className="reveal rounded-[32px] bg-[#14110F] text-white p-10 lg:p-16 flex flex-col lg:flex-row items-center justify-between gap-8 grain relative overflow-hidden">
          <div className="relative max-w-xl">
            <h2 className="font-display font-extrabold text-3xl lg:text-4xl">{w.ctaTitle}</h2>
            <p className="mt-4 text-white/70 text-lg">{w.ctaText}</p>
          </div>
          <Link to={navPaths.allf} className="relative btn-press inline-flex items-center gap-2 rounded-full bg-[#22B573] text-[#083a24] px-7 py-3.5 font-semibold hover:bg-[#1ba065] shrink-0">
            {w.ctaBtn} <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </main>
  );
}
